var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("お支払い方法")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "payment_section" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "payment_credit_area" }, [
                  _c("div", { staticClass: "payment_title" }, [
                    _vm._v("クレジットカードでお支払い")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "payment_msg" }, [
                    _vm._v(
                      "\n              以下のマークがついているクレジットカードでお支払いいただけます。お支払い方法は一括払いのみとなっております。\n              ご注文の確認が出来次第、製造を開始いたします。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "credit_img" }, [
                    _c("img", {
                      attrs: { src: _vm.getImage("guide/credit-card.webp") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "payment_title" }, [
                    _vm._v("金融機関でのお支払い")
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.isCorpLogin
                    ? _c("div", { staticClass: "payment_title" }, [
                        _vm._v("掛け払いサービスについて")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCorpLogin
                    ? _c("div", { staticClass: "payment_msg" }, [
                        _c("div", [
                          _vm._v("\n                法人のお客様は、「"),
                          _c(
                            "span",
                            {
                              staticClass: "link",
                              on: { click: _vm.deferPayment }
                            },
                            [_vm._v("後払いサービス")]
                          ),
                          _vm._v(
                            "」をご利用いただけます。 ＊申込みと審査が必要となります。\n              "
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment_area" }, [
      _c("div", { staticClass: "payment_msg" }, [
        _c("div", [
          _vm._v(
            "\n                以下の方法でお支払いすることができます。お客様のご入金が確認できてから制作に移らせていただきます。\n              "
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                ご入金のタイミングによっては、お届け日が前後する可能性がありますことご了承ください。\n              "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment_msg" }, [
      _c("div", [
        _vm._v(
          "\n                商品は入金確認後に製造開始いたします。 お振込み期限を過ぎますと希望納期に間に合わない場合がございます。\n              "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n                決済ページにより振込先情報・振込期限をご確認の上、期間内にお支払いいただけますようお願い致します。\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d04ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d04ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcGuidePayment.vue
// module id = null
// module chunks = 